export enum BatchTypes {
  SET_UNAPPROVED_BATCH = 'SET_UNAPPROVED_BATCH'
}

export type BatchState = {
  unapprovedBatch: number
}